/** All 24 official EU languages — keep in sync with backend/src/config/euLanguages.ts */
export const EU_LANGUAGES = [
  { code: 'bg', label: 'Български' },
  { code: 'cs', label: 'Čeština' },
  { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' },
  { code: 'el', label: 'Ελληνικά' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'et', label: 'Eesti' },
  { code: 'fi', label: 'Suomi' },
  { code: 'fr', label: 'Français' },
  { code: 'ga', label: 'Gaeilge' },
  { code: 'hr', label: 'Hrvatski' },
  { code: 'hu', label: 'Magyar' },
  { code: 'it', label: 'Italiano' },
  { code: 'lt', label: 'Lietuvių' },
  { code: 'lv', label: 'Latviešu' },
  { code: 'mt', label: 'Malti' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt', label: 'Português' },
  { code: 'ro', label: 'Română' },
  { code: 'sk', label: 'Slovenčina' },
  { code: 'sl', label: 'Slovenščina' },
  { code: 'sv', label: 'Svenska' },
] as const;

export type EuLanguageCode = (typeof EU_LANGUAGES)[number]['code'];

export function isEuLanguageCode(code: string): code is EuLanguageCode {
  return EU_LANGUAGES.some((l) => l.code === code);
}

export function normalizeEuLocale(code?: string | null): EuLanguageCode {
  const base = (code || 'en').split('-')[0]?.toLowerCase();
  return isEuLanguageCode(base) ? base : 'en';
}
